rdefine('app/products/properties/playlist',['backbone','text!products/prop/playlist.html','text!products/prop/playlist-item.html','text!products/prop/playlistitemex.html'],function(Backbone,template,templateItem, templateItemEx) {

    var FactoryOfImageUploads = 0;

    var SoundModelPlayer = Backbone.Ribs.View.extend({
        className:'sound-item',
        media_id:null,
        rawimage: null,
        image:null,
        ignoreupload:true,
        bindings:{
            '.title .progress':{
                toggle:{data:'model.uploaded', processor: function(a) { return !a; }}
            },
            '.title .form-group':{
                toggle:{data:'model.uploaded', processor: function(a) { return a; }}
            },
            '.plyr__controls__item':{
                classes:{
                    'plyr__control--pressed':'model.isplay'
                }
            },
            'input':{
                value:'model.title'
            },
            '.progress-bar-info':{
                css:{
                    'width':{
                        data:'model.progress',
                        processor:function(a){
                            return a + '%';
                        }
                    }
                }
            },
            el:{
                classes:{
                    showed: {
                        data: 'model.deleted',
                        processor: function (deleted) {
                            return !deleted;
                        }
                    }
                }
            }
        },
        events:{
            "click .plyr__controls__item":"playstop",
            "click .btn-danger":"onDelete"
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(templateItem));
            if(this.model.has("rawimage")) {
                this.model.set("uploaded",false);
                this.uploadRawFile();
            }else{
                this.model.set("uploaded",true);
            }
            this.collection.on("stop-all", function() {
                if(this.model.get("isplay")) {
                    this.model.set("isplay",false);
                }
            }.bind(this));
            this.model.on("change:title", function() {
                this.collection.controller.setFromItems();
            }.bind(this));
         /*   var image = this.model.get("image","");
            if(image && image.length) {
                this.media_id = image.split("/").reverse()[0].split("_")[0];
                this.image = image;
            }
            this.rawimage = this.model.get("rawimage",null);*/
            //this.makeCropper();
        },
        uploadRawFile:function() {
            var raw = this.model.get("rawimage");
            var formData = new FormData();
            formData.append("music", raw);
            formData.append('_token',window.csrf);

            $.ajax({
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();

                    xhr.upload.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            percentComplete = parseInt(percentComplete * 100);
                            this.model.set("progress",percentComplete);
                        }
                    }.bind(this), false);

                    return xhr;
                }.bind(this),
                url: "/music/store",
                method: 'POST',
                type: 'POST',
                data:formData,
                contentType: false,
                processData: false,
                success: function(result) {
                    this.model.set("uploaded",true);
                    this.model.set("file",result.filename);
                    this.model.set("id",result.id);
                    this.model.set("title",raw.name);
                    this.collection.controller.setFromItems();
                }.bind(this)
            });
        },
        playstop:function() {
            if(this.model.get("isplay")) {
                this.collection.controller.player.stop();
                this.model.set("isplay",false);
            }else{
                this.collection.controller.play(this.model.get("file"),this.model.get("title"));
                this.collection.trigger('stop-all');
                this.model.set("isplay",true);
            }
            return false;
        },
        onDelete: function() {
            this.model.set('deleted',true);
            if(this.model.get("isplay")) {
                this.collection.controller.player.stop();
            }
            this.collection.controller.setFromItems();
            return false;
        }
    });

    var PlayListItem = Backbone.Ribs.View.extend({
        className:'language-item row',
        bindings:{
            '.name-field':{
                text:'model.name'
            },
            '.drop-zone-file-choices':{
                toggle:{
                    data:'model.uploaded',
                    processor:function(a) { return !a;}
                }
            },
            '.player-wrap':{
                classes: {
                    'isplay':{
                      data:'model.isplay'
                    },
                  'uploading':{
                      data:'model.uploading',
                      processor: function(a) { return a; }
                  },
                    showing:{
                        data:'model.uploaded',
                        processor:function(a) { return a;}
                    }
                }
            },
            '.plyr__controls__item':{
                classes:{
                    'plyr__control--pressed':'model.isplay'
                }
            },
            '.progress-bar-info':{
                css:{
                    'width':{
                        data:'model.progress',
                        processor:function(a){
                            return a + '%';
                        }
                    }
                }
            },
        },
        events:{
            "click .player button":"playstop",
            "click .action button":"onDelete"
        },
        initialize:function(opts) {
            this.$el.html(Template7.compile(templateItemEx)());
            this.$el.find(".drop-zone-file-choices label").attr("for","CARD_MODAL_FACTORY_"+FactoryOfImageUploads);
            this.$el.find(".drop-zone-file-choices input").attr("id","CARD_MODAL_FACTORY_"+FactoryOfImageUploads);
            FactoryOfImageUploads++;

            this.collection.on('stop-all', function(){
                this.model.set("isplay",false);
            }.bind(this));

            this.collection.on('play-for', function(file){
                if(this.model.get("file") === file) {
                    this.model.set("isplay", true);
                }
            }.bind(this));

            this.collection.on('time-for', function(file,progress){
                if(this.model.get("file") === file) {
                    this.model.set("progress", progress*100);
                }
            }.bind(this));

            this.attachImageUploadFactory(this.$el.find(".drop-zone-file-choices input")[0]);
        },
        attachImageUploadFactory:function(el) {
            var content = $(el).parent().find('label')[0];
            content.addEventListener('dragover', this.handleDragOver.bind(this));
            content.addEventListener('dragleave', this.handleDragLeave.bind(this));
            content.addEventListener('drop', this.handleDrop.bind(this));
            el.addEventListener('change', this.handleFileSelect.bind(this));
        },
        handleDragOver: function (e) {
            e.preventDefault();
            if(!this.$el.hasClass("hover-drag"))
                this.$el.addClass("hover-drag");
        },
        handleDragLeave: function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
        },
        handleDrop:function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
            this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
        },
        handleFileSelect:function(e) {
            this.handleFileItems(e.target.files);
        },
        handleFileItems:function(items) {
            var l = items.length;
            for(var i =0;i<l;i++) {
                this.handleItem(items.item(+i));
            }
            this.$el.find(".drop-zone-file-choices input")[0].value = '';
        },
        handleItem:function(item) {

            // get file from item
            var file = item;
            if (item.getAsFile && item.kind =='file') {
                file = item.getAsFile();
            }

            this.handleFile(file);

        },
        handleFile: function(file) {
           this.uploadRawFile(file);
        },
        uploadRawFile:function(raw) {
            var formData = new FormData();
            formData.append("music", raw);
            formData.append('_token',window.csrf);
            this.model.set("uploading",true);

            $.ajax({
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();

                    xhr.upload.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            percentComplete = parseInt(percentComplete * 100);
                            this.model.set("progress",percentComplete);
                        }
                    }.bind(this), false);

                    return xhr;
                }.bind(this),
                url: "/music/store",
                method: 'POST',
                type: 'POST',
                data:formData,
                contentType: false,
                processData: false,
                success: function(result) {
                    this.model.set("uploaded",true);
                    this.model.set("uploading",false);
                    this.model.set("file",result.filename);
                    this.model.set("file_id",result.id);
                    this.model.set("title",raw.name);
                    this.collection.controller.setFromItems();
                }.bind(this)
            });
        },
        playstop:function() {
            if(this.model.get("isplay")) {
                this.collection.controller.stop();
                this.model.set("isplay",false);
            }else{
                this.collection.controller.play(this.model.get("file"),this.model.get("title"));
                this.collection.trigger('stop-all');
                this.model.set("isplay",true);
            }
            return false;
        },
        onDelete: function() {
            if(this.model.get("isplay")) {
                this.collection.controller.player.stop();
            }
            this.model.set("uploaded",false);
            this.model.set("file",null);
            var deletes = this.model.get("deletes",[]);
            if(!deletes) {
                deletes = [];
            }
            deletes.push(this.model.get("file_id"));
            this.model.set("deletes",deletes);
            this.model.set("file_id",null);
            this.collection.controller.setFromItems();
            return false;
        }
    });

    return Backbone.Ribs.View.extend({
        bindings:{
            '.languages-items':{
                collection:{
                    col:'langitems',
                    view:PlayListItem
                }
            }
        },
        images:null,
        current:'',
        initialize:function(options) {
            console.log("PLAYLIST",options);
            this.cform = options.cform;
            this.langitems = new Backbone.Ribs.Collection(_.union([{id:'pure',name:'PureSound'}],_.clone(AllLanguages)), {model:Backbone.Ribs.Model});
            this.langitems.controller = this;
            this.field = 'property_'+this.model.get("id");
            this.$el.html(Template7.compile(template)());
            this.pel = this.$el.find(".play-player");
            this.player = new Plyr(this.$el.find(".play-player audio")[0]);
            this.currentPlay = null;
            this.player.on("ended", function(){
                this.pel.slideUp();
                this.langitems.trigger('stop-all');
            }.bind(this));
            this.player.on("play", function(){
                this.pel.slideDown();
                this.langitems.trigger('play-for',this.currentPlay);
            }.bind(this));
            this.player.on("pause", function(){
                this.pel.slideUp();
                this.langitems.trigger('stop-all');
            }.bind(this));
            this.player.on("timeupdate", function(a) {
                this.langitems.trigger('time-for',this.currentPlay, this.player.currentTime / this.player.duration);
            }.bind(this));

            this.pel.hide();
            this.cform.on("change:"+this.field,function(){
                this.resetItems();
            }.bind(this));

            this.resetItems();
        },
        play: function(source, title) {
            this.currentPlay = source;
            this.pel.slideDown();
            this.player.stop();
            this.player.source = {
                type: 'audio',
                title: title,
                sources: [
                    {
                        src: source,
                        type: 'audio/mp3',
                    }
                ],
            };
            this.player.restart();
            this.player.play();
        },
        stop: function() {
            this.currentPlay = null;
            this.player.stop();
            this.player.restart();
            this.pel.slideUp();
        },
        resetItems: function() {
            var c = this.cform.get(this.field);
            console.log("ABC",c);
            if(c!==this.current) {
                var models = this.langitems.models;
                var items = [];
                try {
                    items = JSON.parse(c);
                } catch (e) {
                    items = [];
                }
                for(var model in models) {
                    console.log("MODEL",model);
                    var m = models[model];
                    for (var key in items) {
                        console.log("KEY", key);
                        if(items[key].id == m.get("id")) {
                            m.set({
                                file:items[key].file,
                                file_id:items[key].file_id,
                                title:items[key].title,
                                uploaded: items[key].file && items[key].file.length,
                                uploading: false
                            });
                            break;
                        }
                    }
                    models[model] = m;
                }
                console.log(models);
                this.langitems.reset(models);
            }
        },
        setFromItems: function() {
            var set = new Array();
            this.langitems.map(function(item){
                set.push(item.attributes);
            });
            this.current = JSON.stringify(set);
            this.cform.set(this.field, this.current);
        }
    });


});